import React from "react"
import { Card, CardBody, Col, Row, Progress } from "reactstrap"
import { formatCurrency } from '../../utils/formatCurrency'

const ICONS = {
  'Total': 'monetization_on',
  'Efectivo': 'payments',
  'MercadoPago': 'fab fa-cc-stripe',
  'Mercado Pago': 'fab fa-cc-stripe',
  'Tarjeta': 'credit_card',
}

const COLORS = {
  'Total': 'primary',
  'Efectivo': 'success',
  'MercadoPago': 'info',
  'Mercado Pago': 'info',
  'Tarjeta': 'warning',
}

const ResumeCash = (props) => {
  const resumeCashData = props.data

  if (!Array.isArray(resumeCashData)) {
    return null;
  }

  const count = resumeCashData.length;
  // xl: fit all in one row (12/count), md: 3 per row, xs: 2 per row
  const xlCol = count <= 6 ? Math.floor(12 / count) : 2;

  return (
    <Row className="g-2 g-md-3">
      {resumeCashData.map((item, key) => {
        const color = COLORS[item.name] || 'secondary'
        const icon = ICONS[item.name] || 'receipt'
        const isFa = icon.startsWith('fa')
        const pct = item.percent ? Math.round(item.percent) : 0

        return (
          <Col key={key} xs={6} md={4} xl={xlCol}>
            <Card className="mb-0 shadow-sm" style={{ borderLeft: `3px solid var(--bs-${color})` }}>
              <CardBody className="py-2 px-3">
                <div className="d-flex align-items-center justify-content-between">
                  <div className="d-flex align-items-center">
                    {isFa
                      ? <i className={`${icon} text-${color} me-2`} style={{ fontSize: 18 }}></i>
                      : <span className={`material-symbols-rounded text-${color} me-2`} style={{ fontSize: 20 }}>{icon}</span>
                    }
                    <span className="text-muted" style={{ fontSize: 12 }}>{item.name}</span>
                  </div>
                  {key > 0 && (
                    <span className="text-muted d-none d-md-inline" style={{ fontSize: 11 }}>{pct}%</span>
                  )}
                </div>
                <h5 className="mb-0 mt-1" style={{ fontSize: 16, fontWeight: 700 }}>
                  {formatCurrency(item.value)}
                </h5>
                {key > 0 && (
                  <Progress
                    value={pct}
                    color={color}
                    className="mt-1"
                    style={{ height: 3 }}
                  />
                )}
              </CardBody>
            </Card>
          </Col>
        )
      })}
    </Row>
  );
};

export default ResumeCash;
